import { Button } from '@sparemin/blockhead';
import IconModal from 'components/IconModal';
import React from 'react';
import { useModalControls } from 'state/modals';
import { CONFIGURE_FEED_URL } from './constants';

type ConfigureFeedModalProps = {};

const ConfigureFeedModal: React.FC<ConfigureFeedModalProps> = () => {
  const { close } = useModalControls();

  return (
    <IconModal
      title="We can’t verify ownership…"
      subtitle="To claim a podcast there must be an owner’s email address available in the RSS feed, but we can’t find one. Please add an email address to your feed so we can verify you own it."
      modalName="ConfigureFeed"
    >
      <Button
        as="a"
        href={CONFIGURE_FEED_URL}
        fluid
        onPress={close}
        target="_blank"
        rel="noreferrer"
      >
        Learn how to add an email to your feed
      </Button>
      <Button fluid onPress={close}>
        No thanks
      </Button>
    </IconModal>
  );
};
export default ConfigureFeedModal;
